import {Datoformatering} from "../tjenester/Datoformatering";

export function mFromNowUtenKlokkeslettFilterForInjisering() {
    return [Datoformatering.regNavn, mFromNowUtenKlokkeslettFilter];
}

/**
 * Formaterer angitt dato som streng.
 * Delegerer til Datoformatering.somFraNåUtenKlokkeslett().
 */
export function mFromNowUtenKlokkeslettFilter(datoformatering: Datoformatering): Function {
    return function (dato: Date) {
        return datoformatering.somFraNåUtenKlokkeslett(dato);
    }
}
